module.exports = __webpack_public_path__ + "static/img/familyImg.5522627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/familyImg.png
// module id = gfsU
// module chunks = 1